/** @format */

import { useRef } from "react";
import Layout from "../components/Layout";
import ShipmentDetails from "../pages/shipments/index";

/** Stable route shell — prevents shipment UI remount on navigation/state updates. */
export default function ShipmentsRoute({ userName }) {
  const sidebarToggleRef = useRef(null);

  return (
    <Layout title="Shipments" userName={userName} hideMobileHeader onSidebarToggleRef={sidebarToggleRef}>
      <ShipmentDetails onToggleSidebar={() => sidebarToggleRef.current?.()} />
    </Layout>
  );
}
